<script>
import DishCard from './dishCard.vue'
import { apiService } from '@/helpers/api.service';

export default {
    components: { DishCard },
    props: {
        dish: {
            type: Object,
            default: null,
        }
    },
    data() {
        return {
        };
    },
    mounted() {
    },
    methods: {
        deactivateActiveDish(){
            this.dish.isActive = false
            apiService.patchIsActive(this.dish._id, {isActive: false})
            .then(() => {
                    this.$bvModal.hide('isActiveDish')
                })
        }
    },
}
</script>

<template>
    <b-modal id="isActiveDish" centered size="lg" hide-footer="true">
        <div class="is-active-dish">
            <h2>¿Desactivar este plato?</h2>
            <p>Dejará de estar visible en Welly Go y tus clientes no podrán realizar pedidos para esta preparación. 
                Podés activarlo de nuevo en la sección Mis platos.</p>
            <DishCard :dish="dish" class="is-active-dish-card"/>
        </div>
        <div class="btn-is-active-container">
            <b-button href="#" type="submit" variant="success" class="btn-is-active btn-cancel" @click="$bvModal.hide('isActiveDish')">
                Cancelar
            </b-button>
            <b-button href="#" type="submit" variant="success" class="btn-is-active" @click="deactivateActiveDish()">
                Si, desactivar
            </b-button>
        </div>
    </b-modal>
</template>

<style lang="scss" scoped>
@import "@/design/settings";
@import '@/design/views/my-dishes/isActiveDishModal';
</style>
